import React from 'react'

import styled, { css } from 'styled-components'

import { palette, transitions } from '_styles/variables'

import { LabelProps } from '../helpers/types'

const ActiveFloatingLabel = css`
  bottom: 100%;
  transform: translateY(calc(100% + 0.375rem));
  font-size: 0.75em;
  color: ${palette.neutral['grey-95989a']};
`

const StyledLabel = styled.label<Omit<LabelProps, 'renderLabel'>>`
  font-size: 1em;
  font-weight: 600;
  margin-bottom: 0.25rem;

  ${({ float, hasIcon, active }) =>
    float &&
    css`
      position: absolute;
      pointer-events: none;
      bottom: 50%;
      transform: translateY(50%);
      left: ${hasIcon ? '2.625rem' : '0.75rem'};
      color: ${palette.neutral['grey-bbbdbf']};
      transition: ${transitions.quick(['all'])};
      margin: 0;

      input:focus + &,
      input:-webkit-autofill + &,
      input:not(:placeholder-shown) + & {
        ${ActiveFloatingLabel}
      }

      ${active && ActiveFloatingLabel}
    `}
`

export const Label: React.FC<LabelProps> = ({
  label,
  renderLabel,
  htmlFor,
  float,
  active,
  hasIcon,
  ...props
}) =>
  typeof renderLabel === 'function' ? (
    renderLabel(htmlFor)
  ) : (
    <StyledLabel
      hasIcon={hasIcon}
      float={float}
      htmlFor={htmlFor}
      active={active}
      {...props}
    >
      {label}
    </StyledLabel>
  )
